import { createFileRoute } from "@tanstack/react-router";
import JwtDecoderPage from "@/pages/JwtDecoderPage";

export const Route = createFileRoute("/tools/jwt-decoder")({
  component: JwtDecoderPage,
});
